import { Auth } from "aws-amplify";
import axios from "axios";

const axiosInstance = axios.create({
    baseURL: process.env.BASE_URL,
});

axiosInstance.interceptors.request.use(async (config: any) => {
    try {
        const session = await Auth.currentSession();
        const token = session.getIdToken().getJwtToken();
        config.headers["Authorization"] = `Bearer ${token}`;
    } catch (error) {
        console.error("Error setting auth token:", error);
    }
    return config;
});

export default axiosInstance;
